//=====================================================
// 再初診ボタン
//=====================================================

interface IFProps {
    enable : boolean,
    onClick? : React.MouseEventHandler<HTMLButtonElement>
}

export function BtnReservationRefirst(props: IFProps){
 
    return (
        <>
            { props.enable ?
                <button onClick={props.onClick}  className="btn btn-primary btn-reserve no-reservation">新規のご予約</button>
                :
                <button className="btn btn-primary btn-reserve no-reservation is-inactive">Webからの予約不可</button>
            }
        </>
    );

}